import { Application, Container, Sprite, Graphics } from 'pixi.js';

export class Scene extends Container {
    update(delta: number) {}

    onResize(width: number, height: number) {}
}
